import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Flame, BarChart3, FileText, Landmark, Wallet } from "lucide-react";

const FEATURES = [
  { icon: BarChart3, title: "Ventas en tiempo real", text: "Integración con el TPV Loyverse: ventas por sucursal, comparativas y mix de pagos." },
  { icon: FileText, title: "Facturas con OCR", text: "Importación automática desde Google Drive o subida directa, con lectura OCR y control de duplicados." },
  { icon: Landmark, title: "Bancos y conciliación", text: "Extractos bancarios importados y conciliados con facturas y pagos, sin duplicar movimientos." },
  { icon: Wallet, title: "Cortes de caja diarios", text: "Cierre diario por sucursal con fondo de caja, ventas, gastos y descuadre informativo." },
];

export default function Landing() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-slate-950 text-white" data-testid="landing-page">
      <header className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-[#D9381E] flex items-center justify-center">
            <Flame className="w-5 h-5 text-white" />
          </div>
          <div className="leading-tight">
            <div className="font-heading font-bold tracking-tight text-lg">ITACATE FINANCE</div>
            <div className="text-[10px] text-slate-400 uppercase tracking-widest">Taquería Mexicana</div>
          </div>
        </div>
        <Link to="/login" data-testid="landing-login-button"
          className="text-sm font-medium bg-[#D9381E] hover:bg-[#B91C1C] transition-colors px-4 py-2 rounded-lg">
          Acceder
        </Link>
      </header>

      <main className="max-w-5xl mx-auto px-6 pt-16 pb-10">
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight max-w-2xl">
          La gestión financiera de ITACATE, en un solo lugar
        </h1>
        <p className="text-slate-400 mt-4 max-w-2xl text-base sm:text-lg">
          ITACATE FINANCE es la herramienta interna de ITACATE TAQUERÍA MEXICANA para controlar ventas,
          facturas de proveedores, bancos, cortes de caja y nóminas de las sucursales de Fuengirola y Málaga.
          El acceso está restringido al personal autorizado.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-12">
          {FEATURES.map((f) => (
            <div key={f.title} className="border border-slate-800 rounded-xl p-5 bg-slate-900/50">
              <f.icon className="w-5 h-5 text-[#D9381E]" />
              <div className="font-semibold mt-3">{f.title}</div>
              <div className="text-sm text-slate-400 mt-1">{f.text}</div>
            </div>
          ))}
        </div>
      </main>

      <footer className="max-w-5xl mx-auto px-6 py-8 border-t border-slate-800 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-400">
        <span>© {new Date().getFullYear()} ITACATE TAQUERÍA MEXICANA</span>
        <Link to="/privacidad" data-testid="landing-privacy-link" className="hover:text-white transition-colors">Política de Privacidad</Link>
        <Link to="/condiciones" data-testid="landing-terms-link" className="hover:text-white transition-colors">Condiciones del Servicio</Link>
        <a href="mailto:itacatetaquerias@gmail.com" className="hover:text-white transition-colors">itacatetaquerias@gmail.com</a>
      </footer>
    </div>
  );
}
